import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const SubFolderIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.5C5 6.67157 5.67157 6 6.5 6H10.471C10.8683 6 11.2279 6.23519 11.3871 6.59918L11.7379 7.40082C11.8971 7.76481 12.2567 8 12.654 8H17.5C18.3284 8 19 8.67157 19 9.5V16.5C19 17.3284 18.3284 18 17.5 18H6.5C5.67157 18 5 17.3284 5 16.5V7.5ZM11.4 12.4V10H12.6V12.4H15V13.6H12.6V16H11.4V13.6H9V12.4H11.4Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { SubFolderIcon };
